var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-select',{attrs:{"fancy":"","items":_vm.items,"value":_vm.contact.DefaultCreatorID,"label":_vm.$ct('default-creator')},on:{"input":function($event){return _vm.onInput($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }